import React from 'react';
import Products from '../products';

const ProductsPage = () => <Products />;

export default ProductsPage;
